import * as React from "react";
import { Link } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme) => ({
  link: {
    background: "transparent",
    color: theme.palette.grey[600],
    cursor: "pointer",
    fontSize: 14,
    height: "auto",
    left: 25,
    position: "absolute",
    textTransform: "uppercase",
    top: 40,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      paddingLeft: 39,
      left: 11,
      top: 19,
    },
    [theme.breakpoints.down("lg")]: {
      left: 0,
      width: '100%',
      textAlign: 'center',
      fontSize: 13
    },
  },
});

function BackLink({ classes, path, text }) {
  return (
    <span className={classes.link}>
      <Link to={path}>{text}</Link>
    </span>
  );
}

export default withStyles(styles, { withTheme: true })(BackLink);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/TopLink/index.jsx